import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNotificationCountersStore = defineStore('notificationCounters', () => {
	const state = {
		newRfps: ref(0),
		newContacts: ref(0),
		newChats: ref(0),
		newChatsList: ref([]),
		totalUnreadNotifications: ref(0),
		totalUnread: ref(0),
	};

	const actions = {};
	const getters = {};

	return { ...state, ...actions, ...getters };
});
